export enum TaxCategoriesEnum {
    State = 'State',
    Central = 'Central',
  }